import request from '@/common/request/request_product'
export default {

  // =============================跨产品通用=============================

  getInfo: (params) => { return request({ url: '/Book/GetInfo', method: 'get', params }) },

  getOne: (params) => { return request({ url: '/Book/GetOne', method: 'get', params }) },

  getList: (params) => { return request({ url: '/Book/GetList', method: 'get', params }) },

  getAppMarketList: (params) => { return request({ url: '/Book/AppMarketGetList', method: 'get', params }) },

  open: (data) => { return request({ url: '/Book/Open', method: 'post', data }) },

  save: (data) => { return request({ url: '/Book/Save', method: 'post', data }) },

  joinRemove: (data) => { return request({ url: '/Book/JoinRemove', method: 'post', data }) },

  joinByPhone: (data) => { return request({ url: '/Book/JoinByPhone', method: 'post', data }) },

  joinCheck: (data) => { return request({ url: '/Book/JoinCheck', method: 'post', data }) },
}